import { z } from 'zod';

/**
 * POST /api/provision-jobs/appci リクエスト・レスポンスの型定義
 * AppCI（GitHub リポジトリ）払い出し機能②のAPI仕様
 */

/** POST /api/provision-jobs/appci リクエストボディの Zod スキーマ */
export const ProvisionJobAppCIRequestSchema = z.object({
  product: z.object({
    product_id: z.string().min(1).max(255),
  }),
  repository: z.object({
    repository_type: z.enum(['cec_template_named', 'existing']),
    repository_name: z
      .string()
      .min(1)
      .max(255)
      .regex(/^[A-Za-z0-9._-]+$/, 'Invalid repository name format'),
  }),
  workspace: z.object({
    workspace_name: z
      .string()
      .min(1)
      .max(8)
      .regex(
        /^[a-z0-9]{1,8}$/,
        'workspace_name must match pattern ^[a-z0-9]{1,8}$',
      ),
    workspace_origin: z.enum(['created_in_job', 'existing']),
  }),
});

/** POST /api/provision-jobs/appci リクエストボディの型 */
export type ProvisionJobAppCIRequest = z.infer<
  typeof ProvisionJobAppCIRequestSchema
>;

/** POST /api/provision-jobs/appci レスポンスボディの Zod スキーマ（201 Created） */
export const ProvisionJobAppCIResponseSchema = z.object({
  job_id: z.string(),
  request_id: z.string(),
  status: z.string(),
  message: z.string(),
});

/** POST /api/provision-jobs/appci レスポンスボディの型 */
export type ProvisionJobAppCIResponse = z.infer<
  typeof ProvisionJobAppCIResponseSchema
>;
